<mat-sidenav-container
  *ngIf="!isInaccessible"
  class="sidenav-container portal-sidebar-shell"
  [class.compact-sidebar]="usesCompactSidebarShell">
  <mat-sidenav
    #drawer
    [disableClose]="(breakPointService.isHandset$ | async) ? 'false' : 'true'"
    [ngClass]="{
      sidenav: !(breakPointService.isTablet$ | async),

      'sidenav-tablet': (breakPointService.isTablet$ | async),

      collapsed: isSidebarCollapsed
    }"
    [class.compact-sidebar]="usesCompactSidebarShell"
    fixedInViewport="(isHandset$ | async) === false"
    [attr.role]="
      (breakPointService.isHandset$ | async) ? 'dialog' : 'navigation'
    "
    [mode]="(breakPointService.isHandset$ | async) ? 'over' : 'side'"
    [opened]="(breakPointService.isHandset$ | async) === false">
    <mat-toolbar>
      <img
        *ngIf="!isSidebarCollapsed"
        class="brand-logo"
        [src]="sidebarLogoUrl"
        (error)="onSidebarLogoError()"
        [attr.alt]="(selectedFund?.name || 'Spike') + ' logo'" />
      <img
        *ngIf="isSidebarCollapsed"
        class="brand-logo brand-logo--compact"
        [class.brand-logo--compact-mark]="usesCompactSidebarLogoMark"
        [src]="sidebarLogoUrl"
        (error)="onSidebarLogoError()"
        [attr.alt]="(selectedFund?.name || 'Spike') + ' logo'" />

    </mat-toolbar>

    <div *ngIf="breakPointService.isHandset$ | async" class="handsetDropDown">
      <mat-form-field
        appearance="fill"
        *ngIf="investors.length > 1; else singleInvestorMobile"
        [matTooltip]="selectedInvestor.name"
        matTooltipPosition="below"
        [matTooltipDisabled]="selectedInvestor.name.length < 10">
        <img
          [src]="tenantLogoUrl || '../../assets/images/gp_icon.svg'"
          (error)="onTenantLogoError()"
          matPrefix
          alt="Tenant logo" />
        <mat-select
          [(value)]="selectedInvestor"
          (selectionChange)="onGPSChange($event.value)"
          #mobileInvestorSelect>
          <mat-option
            *ngFor="let investor of investors"
            [value]="investor"
            (click)="drawer.close()">
            {{ investor.name }}
          </mat-option>
        </mat-select>
        <img
          [ngClass]="{ open: mobileInvestorSelect.panelOpen }"
          class="arrow-down"
          src="../../assets/images/arrow-down.svg"
          matSuffix />
      </mat-form-field>
      <ng-template #singleInvestorMobile>
        <div
          class="single-investor-mobile"
          [matTooltip]="selectedInvestor?.name"
          matTooltipPosition="below"
          [matTooltipDisabled]="selectedInvestor?.name?.length < 14">
          <img
            [src]="tenantLogoUrl || '../../assets/images/gp_icon.svg'"
            (error)="onTenantLogoError()"
            alt="Tenant logo" />
          <div>{{ selectedInvestor.name }}</div>
        </div>
      </ng-template>
    </div>

    <!-- mobile screen menu item -->
    <mat-nav-list class="navList" *ngIf="breakPointService.isHandset$ | async">
      <ng-container *ngFor="let item of visibleMenuItems">
        <mat-divider *ngIf="item.value == 'Settings'"></mat-divider>
        <div
          mat-list-item
          class="menuItem"
          [routerLink]="
            !hasSubMenus(item) && selectedInvestor?.id && selectedFund?.id
              ? [
                  '/gp/' +
                    selectedInvestor?.id +
                    '/vehicle/' +
                    selectedFund?.id +
                    '/' +
                    item.path
                ]
              : null
          "
          routerLinkActive="active-link"
          (keyup.enter)="!hasSubMenus(item) && navigateToComponent(item)"
          (click)="!hasSubMenus(item) && navigateToComponent(item)"
          (click)="!hasSubMenus(item) && onSelectedMenu(item)"
          (click)="toggleMenu(item)"
          (click)="!hasSubMenus(item) && drawer.close()"
          [class.active-link]="isActiveMenu(item)"
          [class.chat-menu-item]="item.key === 'viewChat'">
          <img
            class="icon"
            [src]="item.activeimgURL"
            alt="icon"
            [ngClass]="
              isActiveMenu(item) && !hasSubMenus(item)
                ? 'showActiveImg'
                : 'hideActiveImg'
            " />
          <img
            class="icon"
            [src]="item.imgURL"
            [ngClass]="
              !isActiveMenu(item) || hasSubMenus(item)
                ? 'showInactiveImg'
                : 'hideInactiveImg'
            "
            alt="Menu Icon" />
          <span
            class="icon-title"
            *ngIf="
              (breakPointService.isTablet$ | async) === false &&
              !isSidebarCollapsed
            "
            [ngClass]="item.value === 'Dashboard' ? 'dashboard-icon' : ''">
            {{ item.value }}</span
          >
          <ng-container *ngIf="item.key === 'viewChat'">
            <span
              *ngIf="chatUnreadCount$ | async as unreadCount"
              class="chat-nav-badge"
              [attr.aria-label]="unreadCount + ' unread chat messages'">
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </ng-container>
          <div
            *ngIf="
              hasSubMenus(item) && (breakPointService.isTablet$ | async) === false
            "
            style="margin-left: auto">
            <img
              *ngIf="!item.isToggled"
              src="../../../../assets/images/arrow_right.svg"
              alt="Expand" />
            <img
              *ngIf="item.isToggled"
              src="../../../../assets/images/arrow_up_icon.svg"
              alt="Collapse" />
          </div>
        </div>

        <div
          *ngIf="
            hasSubMenus(item) &&
            item.isToggled &&
            (breakPointService.isTablet$ | async) === false
          ">
          <ng-container *ngFor="let subItem of item.subMenus">
            <span
              mat-list-item
              class="menuItem subMenuItem"
              [routerLink]="
                selectedInvestor?.id && selectedFund?.id
                  ? '/gp/' +
                    selectedInvestor?.id +
                    '/vehicle/' +
                    selectedFund?.id +
                    '/' +
                    (item.path + '/' + subItem.path)
                  : null
              "
              routerLinkActive="active-link"
              (keyup.enter)="navigateToSubmenu(item.path + '/' + subItem.path)"
              (click)="navigateToSubmenu(item.path + '/' + subItem.path)"
              (click)="onSelectedMenu(item)"
              (click)="drawer.close()">
              <!-- Submenu icons for handset -->
              <img
                class="icon"
                [src]="
                  isActiveSubMenu(item, subItem)
                    ? subItem.activeimgURL
                    : subItem.imgURL
                "
                alt="Submenu Icon"
                [ngClass]="{
                  showActiveImg: isActiveSubMenu(item, subItem),
                  showInactiveImg: !isActiveSubMenu(item, subItem)
                }" />
              <span *ngIf="!isSidebarCollapsed">
                {{ subItem.value }}
              </span>
            </span>
          </ng-container>
        </div>
      </ng-container>
    </mat-nav-list>

    <!-- desktop screen menu item -->
    <div
      class="sidenav-section-label"
      *ngIf="
        !(breakPointService.isHandset$ | async) &&
        !(breakPointService.isTablet$ | async) &&
        !isSidebarCollapsed
      ">
      Platform
    </div>
    <mat-nav-list
      class="navList"
      *ngIf="
        !(breakPointService.isHandset$ | async) &&
        !(breakPointService.isTablet$ | async)
      ">
      <ng-container *ngFor="let item of visibleMenuItems">
        <mat-divider *ngIf="item.value == 'Settings'"></mat-divider>
        <div
          mat-list-item
          class="menuItem"
          [routerLink]="
            !hasSubMenus(item) && selectedInvestor?.id && selectedFund?.id
              ? [
                  '/gp/' +
                    selectedInvestor?.id +
                    '/vehicle/' +
                    selectedFund?.id +
                    '/' +
                    item.path
                ]
              : null
          "
          routerLinkActive="active-link"
          (keyup.enter)="!hasSubMenus(item) && navigateToComponent(item)"
          (click)="!hasSubMenus(item) && navigateToComponent(item)"
          (click)="!hasSubMenus(item) && onSelectedMenu(item)"
          (click)="toggleMenu(item)"
          [class.active-link]="isActiveMenu(item)"
          tabindex="0"
          [class.chat-menu-item]="item.key === 'viewChat'">
          <img
            *ngIf="!hasSubMenus(item)"
            class="icon"
            [src]="item.activeimgURL"
            alt="icon"
            [ngClass]="
              isActiveMenu(item) && !hasSubMenus(item)
                ? 'showActiveImg'
                : 'hideActiveImg'
            " />
          <img
            *ngIf="!hasSubMenus(item)"
            class="icon"
            [ngClass]="
              !isActiveMenu(item) || hasSubMenus(item)
                ? 'showActiveImg'
                : 'hideActiveImg'
            "
            [src]="item.imgURL"
            alt="Menu Icon" />
          <img
            *ngIf="hasSubMenus(item)"
            mat-button
            class="icon"
            [src]="item.imgURL"
            alt="Menu Icon" />
          <span
            *ngIf="!isSidebarCollapsed"
            class="icon-title"
            [ngClass]="item.value === 'Dashboard' ? 'dashboard-icon' : ''">
            {{ item.value }}
          </span>
          <ng-container *ngIf="item.key === 'viewChat'">
            <span
              *ngIf="chatUnreadCount$ | async as unreadCount"
              class="chat-nav-badge"
              [attr.aria-label]="unreadCount + ' unread chat messages'">
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </ng-container>
          <div *ngIf="hasSubMenus(item)" style="margin-left: auto">
            <img
              *ngIf="!item.isToggled"
              src="../../../../assets/images/arrow_right.svg"
              alt="Expand" />
            <img
              *ngIf="item.isToggled"
              src="../../../../assets/images/arrow_up_icon.svg"
              alt="Collapse" />
          </div>
        </div>

        <div
          *ngIf="
            hasSubMenus(item) &&
            item.isToggled &&
            (breakPointService.isTablet$ | async) === false
          ">
          <ng-container *ngFor="let subItem of item.subMenus">
            <span
              mat-list-item
              class="menuItem subMenuItem"
              [class.sidebar-collapsed]="isSidebarCollapsed"
              [routerLink]="
                selectedInvestor?.id && selectedFund?.id
                  ? '/gp/' +
                    selectedInvestor?.id +
                    '/vehicle/' +
                    selectedFund?.id +
                    '/' +
                    (item.path + '/' + subItem.path)
                  : null
              "
              routerLinkActive="active-link"
              (keyup.enter)="navigateToSubmenu(item.path + '/' + subItem.path)"
              (click)="navigateToSubmenu(item.path + '/' + subItem.path)"
              (click)="onSelectedMenu(item)">
              <img
                class="icon"
                [src]="
                  isActiveSubMenu(item, subItem)
                    ? subItem.activeimgURL
                    : subItem.imgURL
                "
                alt="Submenu Icon" />
              <span *ngIf="!isSidebarCollapsed">
                {{ subItem.value }}
              </span>
            </span>
          </ng-container>
        </div>
      </ng-container>
    </mat-nav-list>

    <!-- tablet screen menu item -->
    <mat-nav-list class="navList" *ngIf="breakPointService.isTablet$ | async">
      <ng-container *ngFor="let item of visibleMenuItems">
        <mat-divider *ngIf="item.value == 'Settings'"></mat-divider>
        <div
          *ngIf="!hasSubMenus(item)"
          mat-list-item
          class="menuItem"
          [routerLink]="
            !hasSubMenus(item) && selectedInvestor?.id && selectedFund?.id
              ? [
                  '/gp/' +
                    selectedInvestor?.id +
                    '/vehicle/' +
                    selectedFund?.id +
                    '/' +
                    item.path
                ]
              : null
          "
          routerLinkActive="active-link"
          (keyup.enter)="navigateToComponent(item)"
          (click)="!hasSubMenus(item) && navigateToComponent(item)"
          (click)="onSelectedMenu(item)"
          [class.active-link]="isActiveMenu(item)"
          tabindex="0"
          [class.chat-menu-item]="item.key === 'viewChat'">
          <img
            class="icon"
            [src]="item.activeimgURL"
            alt="icon"
            [ngClass]="
              isActiveMenu(item)
                ? 'showActiveImg'
                : 'hideActiveImg'
            " />
          <img
            class="icon"
            [ngClass]="
              !isActiveMenu(item)
                ? 'showActiveImg'
                : 'hideActiveImg'
            "
            [src]="item.imgURL"
            alt="Menu Icon" />
          <ng-container *ngIf="item.key === 'viewChat'">
            <span
              *ngIf="chatUnreadCount$ | async as unreadCount"
              class="chat-nav-badge"
              [attr.aria-label]="unreadCount + ' unread chat messages'">
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </ng-container>
        </div>
        <div
          *ngIf="hasSubMenus(item)"
          mat-list-item
          class="menuItem"
          tabindex="0"
          [matMenuTriggerFor]="menu"
          [class.active-link]="isActiveMenu(item)">
          <img
            mat-button
            [matMenuTriggerFor]="menu"
            class="icon"
            [src]="item.imgURL"
            alt="Menu Icon" />
        </div>

        <mat-menu
          #menu="matMenu"
          class="custom-menu"
          yPosition="below"
          xPosition="after">
          <ng-container
            *ngFor="let subItem of item.subMenus"
            class="custom-mat-container">
            <div
              mat-list-item
              class="custom-menu-item"
              [routerLink]="
                selectedInvestor?.id && selectedFund?.id
                  ? '/gp/' +
                    selectedInvestor?.id +
                    '/vehicle/' +
                    selectedFund?.id +
                    '/' +
                    (item.path + '/' + subItem.path)
                  : null
              "
              routerLinkActive="active-link"
              (keyup.enter)="navigateToSubmenu(item.path + '/' + subItem.path)"
              (click)="navigateToSubmenu(item.path + '/' + subItem.path)"
              (click)="onSelectedMenu(item)">
              {{ subItem.value }}
            </div>
          </ng-container>
        </mat-menu>
      </ng-container>
    </mat-nav-list>

    <div class="sidenav-footer">
      <button
        type="button"
        class="sidenav-profile-card"
        [class.collapsed]="isSidebarCollapsed"
        [matMenuTriggerFor]="profileMenu"
        [matTooltip]="sessionUserName"
        [matTooltipDisabled]="!isSidebarCollapsed && (breakPointService.isTablet$ | async) === false"
        matTooltipPosition="right">
        <span class="sidenav-profile-avatar">{{ sessionUserInitials }}</span>
        <span
          class="sidenav-profile-text"
          *ngIf="
            (breakPointService.isTablet$ | async) === false &&
            !isSidebarCollapsed
          ">
          <span class="sidenav-profile-name">{{ sessionUserName }}</span>
          <span class="sidenav-profile-role">{{
            (userService.isMainUser$ | async) ? 'Admin' : 'Member'
          }}</span>
        </span>
        <mat-icon
          class="sidenav-profile-chevron"
          *ngIf="
            (breakPointService.isTablet$ | async) === false &&
            !isSidebarCollapsed
          ">
          chevron_right
        </mat-icon>
      </button>
      <mat-menu
        #profileMenu="matMenu"
        class="profile-menu"
        xPosition="after"
        yPosition="above">
        <button mat-menu-item (click)="openTermsOfUse()">
          <span class="profile-menu__icon" aria-hidden="true">
            <img src="../../../../assets/images/terms_icon.svg" alt="" />
          </span>
          <span class="profile-menu__label">Terms of use</span>
        </button>
        <button mat-menu-item (click)="openDialog(false, '')">
          <span class="profile-menu__icon" aria-hidden="true">
            <img src="../../../../assets/images/signout_icon.svg" alt="" />
          </span>
          <span class="profile-menu__label">{{
            'translations.logOut' | translate
          }}</span>
        </button>
      </mat-menu>
    </div>
  </mat-sidenav>

  <mat-sidenav-content
    class="componentClass"
    (scroll)="onMainContentScroll($event)"
    [class.sidebar-collapsed]="isSidebarCollapsed"
    [class.tablet]="breakPointService.isTablet$ | async"
    [class.mobile]="breakPointService.isHandset$ | async"
    [class.desktop]="
      !(breakPointService.isTablet$ | async) &&
      !(breakPointService.isHandset$ | async)
    "
    [class.compact-sidebar]="usesCompactSidebarShell"
    [class.edge-to-edge-page-shell]="usesEdgeToEdgePageShell"
    [class.chat-page-shell]="isChatPage"
    [class.investor-detail-shell]="isInvestorDetailRoute()">
    <div
      class="header"
      [ngClass]="{
        'small-mobile': (breakPointService.isSmallerHandset$ | async),
        'single-investor-mode': investors.length <= 1,
        'header--scrolled': isMainContentScrolled
      }">
      <button
        type="button"
        aria-label="Toggle sidenav"
        (click)="drawer.toggle()"
        mat-icon-button
        *ngIf="breakPointService.isHandset$ | async"
        style="z-index: 1">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <button
        *ngIf="(breakPointService.isHandset$ | async) === false"
        type="button"
        mat-icon-button
        disableRipple
        class="sidebar-header-toggle"
        [attr.aria-label]="
          isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'
        "
        [attr.aria-pressed]="isSidebarCollapsed"
        (click)="toggleSidebar()">
        <svg
          class="sidebar-header-icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true">
          <path
            d="M6 2V14M3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2Z"
            stroke="black"
            stroke-opacity="0.87"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <span
        *ngIf="(breakPointService.isHandset$ | async) === false"
        class="header-title-divider"
        aria-hidden="true"></span>
      <div
        class="header-left"
        *ngIf="(breakPointService.isHandset$ | async) === false">
        <div class="header-page-title">
          {{ detailPageTitle() || selectedMenu?.value }}
        </div>

        <div class="dashBoardTitle" *ngIf="investors.length > 1">
        <mat-form-field
          appearance="fill"
          class="fundDropdown header-select"
          *ngIf="funds.length > 1"
          [matTooltip]="selectedFund?.name || ''"
          matTooltipPosition="below"
          [matTooltipDisabled]="selectedFund?.name?.length < 10">
          <img
            [src]="
              selectedFund?.imageUrl ||
              selectedFund?.logoUrl ||
              '../../assets/images/fund_icon.svg'
            "
            matPrefix
            alt="Fund logo" />
          <mat-select
            [(value)]="selectedFund"
            (selectionChange)="onVehicleChange($event.value)"
            #fundSelect>
            <mat-option
              class="fund-item"
              *ngFor="let fund of funds"
              [value]="fund">
              {{ fund.name }}
            </mat-option>
          </mat-select>
          <img
            class="arrow-down"
            [ngClass]="{ open: fundSelect.panelOpen }"
            src="../../assets/images/arrow-down.svg"
            matSuffix />
        </mat-form-field>
        <ng-template #singleFund>
          <div class="single-fund">
            <img
              [src]="
                selectedFund?.imageUrl ||
                selectedFund?.logoUrl ||
                '../../assets/images/fund_icon.svg'
              "
              alt="Fund logo" />
            <div>{{ selectedFund.name }}</div>
          </div>
        </ng-template>

        <div class="bread-crumb">
          <ng-container *ngIf="funds.length == 1">
            <div class="single-fund">
              <img
                [src]="
                  selectedFund?.imageUrl ||
                  selectedFund?.logoUrl ||
                  '../../assets/images/fund_icon.svg'
                "
                alt="Fund logo" />
              <div>{{ selectedFund.name }}</div>
            </div>
            <img src="../../../../assets/images/arrow_right_icon.svg" alt="" />
          </ng-container>
          <!--
          <span
            class="primary-path"
            [ngClass]="{
              hover: (commonService.secondaryPathObservable$ | async)?.length
            }"
            [ngStyle]="{
              'pointer-events': !(
                commonService.secondaryPathObservable$ | async
              )?.length
                ? 'none'
                : 'auto'
            }"
            (click)="
              breadCrumbNavigate(
                [selectedMenu.viewValue],
                selectedMenu.viewValue,
                'primary'
              )
            ">
            {{ selectedMenu.viewValue }}</span
          >
          <ng-container *ngIf="!(breakPointService.isSmallerHandset$ | async)">
            <ng-container
              *ngIf="
                commonService.secondaryPathObservable$ | async as secondaryPaths
              ">
              <ng-container
                *ngFor="
                  let path of commonService.secondaryPathObservable$ | async;
                  index as i
                ">
                <img
                  src="../../../../assets/images/arrow_right_icon.svg"
                  alt="" />
                <span
                  class="path-name"
                  (click)="
                    breadCrumbNavigate(
                      secondaryPaths.slice(0, i + 1),
                      selectedMenu.viewValue,
                      'secondary'
                    )
                  "
                  [ngClass]="{
                    hover:
                      i + 1 !==
                      (commonService.secondaryPathObservable$ | async)?.length
                  }"
                  [ngStyle]="{
                    'pointer-events':
                      i + 1 !==
                      (commonService.secondaryPathObservable$ | async)?.length
                        ? 'auto'
                        : 'none'
                  }"
                  >{{ path }}</span
                >
              </ng-container>

            </ng-container>

          </ng-container>
            -->
        </div>
        </div>
      </div>

      <!-- CENTER: Notification or Spacer (to maintain layout stability) -->
      <ng-container *ngIf="showNotification; else notificationSpacer">
        <ng-container [ngTemplateOutlet]="notificationBanner"></ng-container>
      </ng-container>
      <ng-template #notificationSpacer>
        <div class="notification-spacer" *ngIf="investors.length <= 1"></div>
      </ng-template>

      <!-- Right group: Ops presence + Investor Selection. Kept in one flex box
           so the header's space-between can't strand the ops cluster in the
           middle when the centre spacer isn't rendered (investors.length > 1). -->
      <div class="header-right">
        <app-ops-presence
          [gpId]="selectedInvestor?.id"
          [vehicleId]="selectedFund?.id"></app-ops-presence>

        <span class="header-actions-divider" aria-hidden="true"></span>

        <app-quick-task [enabled]="canCreateTasks"></app-quick-task>

        <div class="notification-control">
          <button
            type="button"
            class="header-icon-btn"
            aria-label="Notifications"
            [attr.aria-expanded]="isNotificationPanelOpen"
            aria-haspopup="dialog"
            (click)="toggleNotificationPanel($event)">
            <mat-icon>notifications_none</mat-icon>
            <span
              *ngIf="aceUnreadCount$ | async as unreadCount"
              class="notification-badge"
              [attr.aria-label]="unreadCount + ' unread notifications'">
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </button>

          <section
            *ngIf="isNotificationPanelOpen"
            class="notification-panel"
            role="dialog"
            aria-label="Notifications">
            <div class="notification-panel-header">
              <div>
                <h2>Notifications</h2>
                <span *ngIf="aceUnreadCount$ | async as unreadCount">
                  {{ unreadCount }} unread
                </span>
              </div>
              <button
                *ngIf="aceUnreadCount$ | async as unreadCount"
                type="button"
                class="notification-mark-all"
                [disabled]="unreadCount === 0"
                (click)="markAllAceNotificationsAsRead($event)">
                Mark all read
              </button>
            </div>

            <div
              *ngIf="aceNotificationsLoading$ | async; else loadedAceNotifications"
              class="notification-state"
              aria-live="polite">
              Loading notifications…
            </div>

            <ng-template #loadedAceNotifications>
              <div
                *ngIf="aceNotificationsError$ | async as notificationError"
                class="notification-state notification-state-error"
                role="alert">
                <span>{{ notificationError }}</span>
                <button
                  type="button"
                  class="notification-retry"
                  (click)="refreshAceNotifications(); $event.stopPropagation()">
                  Retry
                </button>
              </div>

              <ng-container *ngIf="aceNotifications$ | async as apiNotifications">
                <div
                  *ngIf="apiNotifications.length; else noAceNotifications"
                  class="notification-list">
                  <button
                    *ngFor="let notification of apiNotifications"
                    type="button"
                    class="notification-item"
                    [class.unread]="!notification.read"
                    (click)="openAceNotification(notification, $event)">
                    <span
                      class="notification-item-icon"
                      [ngClass]="notificationIconTone(notification.type)"
                      aria-hidden="true">
                      <mat-icon>{{ notificationIcon(notification.type) }}</mat-icon>
                    </span>
                    <span class="notification-item-content">
                      <span class="notification-item-title">{{ notification.title }}</span>
                      <span class="notification-item-body">
                        {{ notification.data.body || notification.title }}
                      </span>
                      <span class="notification-item-date">
                        {{ notification.audit.createdDate | date: 'MMM d, y, h:mm a' }}
                      </span>
                    </span>
                    <span
                      *ngIf="!notification.read"
                      class="notification-unread-dot"
                      aria-label="Unread"></span>
                  </button>
                </div>
                <ng-template #noAceNotifications>
                  <div class="notification-state">You're all caught up.</div>
                </ng-template>
              </ng-container>
            </ng-template>
          </section>
        </div>

        <span class="header-actions-divider" aria-hidden="true"></span>

        <div
          *ngIf="(breakPointService.isHandset$ | async) === false"
          class="investorDropdown">
          <ng-container *ngIf="investors.length > 1; else singleInvestor">
            <mat-form-field
              appearance="fill"
              class="header-select"
              [matTooltip]="selectedInvestor?.name"
              matTooltipPosition="below"
              [matTooltipDisabled]="selectedInvestor?.name?.length < 10">
              <img
                [src]="tenantLogoUrl || '../../assets/images/gp_icon.svg'"
                (error)="onTenantLogoError()"
                matPrefix
                alt="Tenant logo" />
              <mat-select
                [(value)]="selectedInvestor"
                (selectionChange)="onGPSChange($event.value)"
                #investorSelect>
                <mat-option
                  class="investor-item"
                  *ngFor="let investor of investors"
                  [value]="investor">
                  {{ investor.name }}
                </mat-option>
              </mat-select>
              <img
                class="arrow-down"
                [ngClass]="{ open: investorSelect.panelOpen }"
                src="../../assets/images/arrow-down.svg"
                matSuffix />
            </mat-form-field>
          </ng-container>

          <!-- SINGLE INVESTOR: fund/owner display only -->
          <ng-template #singleInvestor>
            <div
              class="fund-owner-info"
              [matTooltip]="selectedFund?.name + ' - ' + selectedInvestor?.name"
              matTooltipPosition="below">
              <img
                class="fund-avatar"
                [src]="
                  selectedFund?.imageUrl ||
                  selectedFund?.logoUrl ||
                  tenantLogoUrl ||
                  '../../assets/images/gp_icon.svg'
                "
                (error)="onTenantLogoError()"
                alt="fund logo" />
              <div class="fund-owner-text">
                <span class="fund-name">{{ selectedFund?.name }}</span>
                <span class="owner-label">{{ selectedInvestor?.name }}</span>
              </div>
              <img
                *ngIf="funds.length > 1"
                class="arrow-down"
                src="../../assets/images/arrow-down.svg"
                alt="" />
            </div>
          </ng-template>
        </div>
      </div>
      <button
        *ngIf="isChatPage"
        type="button"
        class="chat-base-new-button"
        aria-label="Start a new chat"
        title="New chat"
        (click)="openChatCreatePanel()">
        <mat-icon aria-hidden="true">add</mat-icon>
      </button>
      <span
        *ngIf="isChatPage"
        class="chat-header-panel-separator"
        aria-hidden="true"></span>
    </div>
    <div
      class="main-content-container"
      [class.edge-to-edge-page-shell]="usesEdgeToEdgePageShell"
      [class.chat-page-shell]="isChatPage">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<div
  class="global-chat-toast-region"
  role="status"
  aria-live="polite"
  aria-atomic="true">
  <div
    *ngIf="chatNotifications.popup$ | async as popup"
    class="global-chat-toast">
    <button
      type="button"
      class="global-chat-toast-main"
      (click)="chatNotifications.openPopup()">
      <span class="global-chat-toast-avatar" aria-hidden="true">
        {{ popup.initials }}
      </span>
      <span class="global-chat-toast-copy">
        <strong>{{ popup.title }}</strong>
        <span>{{ popup.body }}</span>
      </span>
    </button>
    <button
      type="button"
      class="global-chat-toast-close"
      aria-label="Dismiss new message"
      (click)="chatNotifications.dismissPopup()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
</div>

<!-- Reusable Notification Banner Template -->
<ng-template #notificationBanner>
  <div
    class="notification-banner"
    *ngIf="showNotification && notifications[currentNotificationIndex]">
    <span class="notification-text">
      <strong>{{ notifications[currentNotificationIndex].title }}:</strong>
      {{ notifications[currentNotificationIndex].message }}
    </span>
    <button
      class="close-btn"
      type="button"
      (click)="closeNotification()"
      aria-label="Dismiss notification">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #menuItemLoader>
  <div *ngFor="let number of [0, 1, 2, 3, 4, 5, 6, 7, 8]">
    <div class="menuItemLoader">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{
          width: '30px',
          height: '30px'
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader
        *ngIf="
          (breakPointService.isTablet$ | async) === false && !isSidebarCollapsed
        "
        count="1"
        appearance="line"
        [theme]="{
          width: '130px'
        }"></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>

<ng-template #logoLoader>
  <div class="logoLoader">
    <ngx-skeleton-loader
      *ngIf="!(breakPointService.isTablet$ | async)"
      count="1"
      appearance="line"
      [theme]="{
        width: '130px',
        height: '60px'
      }"></ngx-skeleton-loader>
    <ngx-skeleton-loader
      *ngIf="breakPointService.isTablet$ | async"
      count="1"
      appearance="line"
      [theme]="{
        width: '60px',
        height: '40px'
      }"></ngx-skeleton-loader>
  </div>
</ng-template>
